import React from "react";
import theme from "app/Theme/Theme";
import { Box, MainText, PressableOpacity } from "app/components/common";
import normalize from "app/utils/normalize";
import MultipleAvatars from "../TeamScreen/MultipleAvatars";
import { IRankingUser } from "@microdoing/shared/services/ranking/types";
import FlashIcon from "app/components/Icons/FlashIcon";

interface IProps {
  rank: number;
  user: IRankingUser;
  name?: string;
  totalDoneActions?: number;
  isUser: boolean;
  onPress: () => void;
}

const UserRankingRow = ({
  rank = 1,
  user,
  name,
  totalDoneActions,
  isUser = false,
  onPress,
}: IProps) => {
  const { firstName, lastName, points } = user;

  return (
    <PressableOpacity testID={`user-ranking-${rank}`} onPress={onPress}>
      <Box
        paddingHorizontal="xm"
        paddingVertical="m"
        flexDirection="row"
        alignItems="center"
      >
        <Box flexDirection="row" alignItems="center" marginRight="sl">
          <MainText marginRight="m" variant="l4-regular">
            {rank}
          </MainText>
          <MultipleAvatars avatars={[user]} size={normalize(36)} />
        </Box>
        <Box flex={1} flexDirection="column">
          {!!name && (
            <MainText
              variant={!isUser ? "l4-regular" : "l4-semibold"}
              numberOfLines={1}
              marginRight="xs"
            >
              {name}
            </MainText>
          )}
          {!!firstName && (
            <MainText
              variant={!isUser ? "l4-regular" : "l4-semibold"}
              numberOfLines={1}
              marginRight="xs"
            >
              {`${firstName} ${lastName}`}
            </MainText>
          )}
        </Box>
        <Box flexDirection="row" alignItems="center">
          <Box
            alignItems="center"
            justifyContent="flex-end"
            flexDirection="row"
          >
            <MainText variant="l3-medium" marginRight="xxs">
              {!!points ? points : totalDoneActions}
            </MainText>
            <FlashIcon
              width={normalize(16)}
              height={normalize(16)}
              color={theme.colors["brand.500"]}
            />
          </Box>
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export default UserRankingRow;
